module.exports = __webpack_public_path__ + "static/img/arikitarinakotobajyanakute_model.2bdf6a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top/arikitarinakotobajyanakute_model.jpg
// module id = gNde
// module chunks = 0